import scroll from 'utilities/scroll';
import { isCountrySpain } from 'utilities/multiLanguageHelper';
import { SECTION_FIELDS } from '../constants';
import { COUNTRY_DOCUMENT_TYPE_DNI } from 'constants/multiLanguage';
import { doTagIsValidAndGoNext } from '../tagging';
import DOCUMENT_CODES from 'commons-components/src/constants/documentCodes';

export const useSectionFieldsValidation = ({
    userProfile,
    userProfileForm,
    formActions,
    isPassportRequired,
    handleValidateSection,
}) => {
    const { isValidatingTin } = userProfile;

    const FIELDS_WITH_CONDITIONS_TO_VALIDATE = [
        { condition: !isCountrySpain(), field: 'tin' },
        { condition: DOCUMENT_CODES.DOCUMENT_NIF === userProfile.documentType, field: 'secondLastName' },
        { condition: isPassportRequired, field: 'passport' },
    ];
    const areAllFieldsFilled = () => {
        return (
            SECTION_FIELDS.every(field => userProfile[field]) &&
            FIELDS_WITH_CONDITIONS_TO_VALIDATE.every(({ condition, field }) => (condition ? userProfile[field] : true))
        );
    };
    const isFormWithErrors = !areAllFieldsFilled() || !userProfileForm.$form.valid || isValidatingTin;

    const onValidateSection = () => {
        if (isFormWithErrors) {
            const { documentType } = userProfile;
            const sectionFieldsWithErrors = SECTION_FIELDS.map(fieldName => {
                if (fieldName === 'docNumber' && userProfile['nationality'] && !userProfile['docNumber']) {
                    formActions.setValidity('userProfile.docNumber', { required: '' });

                    return fieldName;
                }

                if (!userProfile[fieldName]) {
                    formActions.setValidity(`userProfile.${fieldName}`, { required: '' });

                    return fieldName;
                }
                if (userProfileForm[fieldName] && !userProfileForm[fieldName].valid) return fieldName;

                return null;
            });
            const conditionalSectionFieldsWithErros = FIELDS_WITH_CONDITIONS_TO_VALIDATE.map(({ field, condition }) => {
                if (condition && !userProfile[field]) {
                    formActions.setValidity(`userProfile.${field}`, { required: '' });

                    return field;
                }
                if (condition && userProfileForm[field] && !userProfileForm[field].valid) return field;

                return null;
            });
            const fieldsWithErrros = [...sectionFieldsWithErrors, ...conditionalSectionFieldsWithErros].filter(Boolean);
            if (documentType === COUNTRY_DOCUMENT_TYPE_DNI && !userProfile['secondLastName']) {
                formActions.setValidity('userProfile.secondLastName', { required: '' });
                fieldsWithErrros.push('secondLastName');
            }

            if (!userProfile['birthDate']) {
                formActions.setValidity('userProfile.birthDate', { required: '' });
                fieldsWithErrros.push('birthDate');
                if (!userProfile['birthDay']) {
                    formActions.setValidity('userProfile.birthDay', { required: '' });
                }
                if (!userProfile['birthMonth']) {
                    formActions.setValidity('userProfile.birthMonth', { required: '' });
                }
                if (!userProfile['birthYear']) {
                    formActions.setValidity('userProfile.birthYear', { required: '' });
                }
            }
            const firstFieldElementWithError = document.getElementById(fieldsWithErrros[0]);
            firstFieldElementWithError && scroll.transition(firstFieldElementWithError, 'top', 1, 0, -57);

            return;
        }

        doTagIsValidAndGoNext();
        handleValidateSection();
    };

    return { isFormWithErrors, onValidateSection };
};
